import { RootState } from "@/store/store";
import { commitmentsDetailsDrawerDetailsSelector } from "@/store/commitments/selectors/common/details-drawer/commitmentsDetailsDrawerDetailsSelector";

export const savingsPlanSelectedCoverageDataAccountNameAndIdSelector = (
  state: RootState,
): string => {
  const { accountName, accountProviderId } =
    commitmentsDetailsDrawerDetailsSelector(state);

  return `${accountName} (${accountProviderId})`;
};
